import { render, staticRenderFns } from "./Briefcase.vue?vue&type=template&id=4e8dae4c"
import script from "./Briefcase.vue?vue&type=script&lang=js"
export * from "./Briefcase.vue?vue&type=script&lang=js"
import style0 from "./Briefcase.vue?vue&type=style&index=0&id=4e8dae4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports